import { render, staticRenderFns } from "./uranus.vue?vue&type=template&id=611271d6&"
import script from "./uranus.vue?vue&type=script&lang=js&"
export * from "./uranus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports